export default "__VITE_ASSET__67cwQVwg__"